module.exports = __webpack_public_path__ + "static/media/urbanFutures_white_logo.5aa303fc.svg";